// eslint-disable-next-line import/prefer-default-export
export const SET_CLOSE_MENU = "SET_CLOSE_MENU";
